import { memo, useEffect, useRef } from "react";
import { Card, Typography } from "antd";
import type { SlideComponentProps } from "./SlideRenderer";
import { StreamingText } from "./StreamingText";
import { ANIMATION } from "./animationConfig";
import { useAnimationSequence } from "./useAnimationSequence";
import { QuotePlaceholders } from "types/";

export const QuoteSlide = memo(
  ({ slide, isActive = false, onComplete }: SlideComponentProps) => {
    const placeholders = slide.placeholders as QuotePlaceholders;
    const quote = placeholders.quote;
    const hasCalledComplete = useRef(false);

    // Steps: 0=quote
    const totalSteps = 1;
    const { nextStep, isStepActive, isComplete } = useAnimationSequence(
      totalSteps,
      isActive
    );

    // Notify parent when complete (once)
    useEffect(() => {
      if (isComplete && onComplete && !hasCalledComplete.current) {
        hasCalledComplete.current = true;
        onComplete();
      }
    }, [isComplete, onComplete]);

    // Not active yet - render static content
    if (!isActive) {
      return (
        <Card>
          <Typography.Text italic style={{ fontSize: 18 }}>
            &ldquo;{quote}&rdquo;
          </Typography.Text>
        </Card>
      );
    }

    return (
      <Card>
        {/* Step 0: Quote */}
        {isStepActive(0) && (
          <Typography.Text italic style={{ fontSize: 18 }}>
            &ldquo;
            <StreamingText
              text={quote}
              animate
              wordDelay={ANIMATION.WORD_DELAY}
              onComplete={nextStep}
            />
            &rdquo;
          </Typography.Text>
        )}
      </Card>
    );
  }
);

QuoteSlide.displayName = "QuoteSlide";
